// extracted by mini-css-extract-plugin
export default {"skills-container":"skills_skills-container__hNBrJ","title":"skills_title__bV+Nd","skills-content":"skills_skills-content__QDuYL","skill":"skills_skill__4m2k+"};